// Implant act label mappings, extracted from pec-extension content.ts
// to be reused both by the sidepanel (resolve act kind from ccam_code)
// and the content script (label-based option matching).
export const groupedTreatmentPlanActCodes = new Set([
    "LBLD015",
    "LBLD010",
    "LBLD013",
    "LBLD004",
    "LBLD020",
    "LBLD025",
    "LBLD026",
    "LBLD038",
    "LBLD200",
    "LBLD294",
    "LBLD261",
    "HBLD012",
    "HBLD017",
    "HBLD021",
    "HBLD013",
    "HBLD005",
]);
export const implantPlacementActLabelsByCode = {
    LBLD015: ["Pose d'un implant"],
    LBLD010: ["Pose de deux implants"],
    LBLD013: ["Pose de trois implants"],
    LBLD004: ["Pose de quatre implants"],
    LBLD020: ["Pose de cinq implants"],
    LBLD025: ["Pose de six implants"],
    LBLD026: ["Pose de sept implants"],
    LBLD038: ["Pose de huit implants"],
    LBLD200: ["Pose de neuf implants"],
    LBLD294: ["Pose de dix implants"],
    LBLD261: ["Pose de onze implants et plus"],
};
export const implantAbutmentActLabelsByCode = {
    HBLD012: ["Pose d'un pilier sur implant", "Pilier sur implant"],
    HBLD017: ["Pose de deux piliers sur implant", "Deux piliers sur implant"],
    HBLD021: ["Pose de trois piliers sur implant", "Trois piliers sur implant"],
    HBLD013: ["Pose de quatre piliers sur implant", "Quatre piliers sur implant"],
    HBLD005: [
        "Pose de cinq piliers sur implant",
        "Pose de cinq piliers et plus sur implant",
        "Cinq piliers sur implant",
    ],
};
export const implantCountTokensByCode = {
    LBLD015: ["un", "1"],
    LBLD010: ["deux", "2"],
    LBLD013: ["trois", "3"],
    LBLD004: ["quatre", "4"],
    LBLD020: ["cinq", "5"],
    LBLD025: ["six", "6"],
    LBLD026: ["sept", "7"],
    LBLD038: ["huit", "8"],
    LBLD200: ["neuf", "9"],
    LBLD294: ["dix", "10"],
    LBLD261: ["onze", "11", "plus"],
    HBLD012: ["un", "1"],
    HBLD017: ["deux", "2"],
    HBLD021: ["trois", "3"],
    HBLD013: ["quatre", "4"],
    HBLD005: ["cinq", "5", "plus"],
};
//# sourceMappingURL=ImplantActLabels.js.map